import i18n from "i18next"

export type ExportDetailsFlow = "export" | "publish"

export interface ExportDetails {
	flow: ExportDetailsFlow
	completedFilenames: string[]
	failedFilenames: string[]
	oversizeFilenames: string[]
}

export const buildExportDetails = (options: {
	flow: ExportDetailsFlow
	completedFilenames: string[]
	allFilenames: string[]
	failedFilenames?: string[]
	oversizeFilenames?: string[]
}): ExportDetails => {
	const completedSet = new Set(options.completedFilenames)
	const oversizeFilenames = options.oversizeFilenames ?? []
	const oversizeSet = new Set(oversizeFilenames)

	return {
		flow: options.flow,
		completedFilenames: options.completedFilenames,
		oversizeFilenames,
		failedFilenames:
			options.failedFilenames?.filter((filename) => !oversizeSet.has(filename)) ??
			options.allFilenames.filter(
				(filename) => !completedSet.has(filename) && !oversizeSet.has(filename),
			),
	}
}

export const getExportDetailsSummary = (details: ExportDetails) => {
	const completedCount = details.completedFilenames.length
	const failedCount = details.failedFilenames.length + details.oversizeFilenames.length
	const flow = details.flow

	return i18n.t(`exportDetailsView.${flow}Summary`, {
		ns: "components",
		completedCount,
		failedCount,
	})
}

export const shouldShowExportDetails = (details?: ExportDetails) => {
	return (details?.failedFilenames.length ?? 0) + (details?.oversizeFilenames.length ?? 0) > 0
}
